var classof = require('../internals/classof-raw');
var global = require('../internals/global');

module.exports = classof(global.process) == 'process';



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/engine-is-node.js
// module id = 438
// module chunks = 1 2 3 4